import { faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useEffect, useRef } from 'react';

import { ButtonValid, CardV2 as Card } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { flattenErrors } from '@feathr/hooks';

import { useEventSettingsInfo } from './EventSettingsInfo.hooks';
import ProjectSettingsCards from './ProjectSettingsCards';
import ProjectVisibilityToggle from './ProjectVisibilityToggle';

function EventSettingsInfo(): JSX.Element {
  const { event, fields, hasInvites, isDirty, localUrl, setRightActions, t } =
    useEventSettingsInfo();
  const { errors, handleSave } = fields;

  const hasErrors = flattenErrors(errors).length > 0;
  const handleSaveRef = useRef(handleSave);
  handleSaveRef.current = handleSave;

  useEffect(() => {
    setRightActions(
      <ButtonValid
        disabled={isDirty ? undefined : true}
        errors={flattenErrors(errors)}
        onClick={(): Promise<void> => handleSaveRef.current()}
        prefix={<FontAwesomeIcon icon={faSave} />}
      >
        {t('Save changes')}
      </ButtonValid>,
    );
  }, [isDirty, hasErrors]);

  return (
    <Page
      collapseHeader={false}
      collapseHeaderOnScroll={true}
      description={t("Manage this project's details, schedule, page domains, and status.")}
      includeCurrentPageCrumb={true}
      loading={event.isPending}
      showHeader={true}
      title={t('Project Information')}
    >
      <ProjectSettingsCards
        advertisersUrl={localUrl('settings/account/advertisers')}
        event={event}
        fields={fields}
        hasInvites={hasInvites}
      />
      <Card name={'visibility-card'}>
        <ProjectVisibilityToggle event={event} />
      </Card>
    </Page>
  );
}

export default observer(EventSettingsInfo);
